export default __webpack_public_path__ + "static/media/Childhood and Adulthood 2017 -- Charcoal and Pastel on Paper -- 24in x 19in.8302e797.JPG";